var BillingMixins = require('billingmixins');
var BackendController = require('backendcontroller');
var Buf = require('buf');
var BufferList = require('bufferlist');
var PinnedBufferList = require('pinnedbufferlist');
var Connection = require('connection');
var ConnectionList = require('connectionlist');
var OrgList = require('orglist');
var FileList = require('filelist');
var PastebinList = require('pastebinlist');
var User = require('user');
var ViewState = require('viewstate');
var perf = require('../lib/perf.es6');


var Session = Backbone.Model.extend($.extend(true, {}, BillingMixins, {
    hardZombie: null,
    softZombie: null,
    prefs: {},
    plans: {},
    timing: {},
    postMessages: [],
    streamConnected: false,
    initialize: function () {
        _.bindAll(this, 'addNetwork');
        
        this.session = this;
        
        this.bind('change:prefs', this.parsePrefs, this);
        this.bind('change:verified', this.setUser, this);
        this.bind('change:name', this.setUser, this);
        this.bind('change:email', this.setUser, this);
        this.bind('change:avatar', this.setUser, this);
        this.bind('change:avatar_url', this.setUser, this);
        this.bind('change:orgs', this.processOrgs, this);
        
        this.supported = true;
        this.backend = new BackendController(this);
        this.backend.bind('streamAuthError', this.doLogout, this);
        this.backend.bind('setShard', this.setShard, this);
        this.backend.bind('unsupported', this.unsupported, this);
        this.backend.bind('xhrFallback', this.setXhrFallback, this);
        
        this.backend.bind('oobLoading', function sessionOOBLoading () {
            var key = 'oob' + (this.isInitialized() ? 'Re' : '') + 'Load';
            debug.timeStamp(key);
            perf.mark(key);
        }, this);
        this.backend.bind('oobFailed', function sessionOOBFailed () {
            // Just clear the key
            var key = 'oob' + (this.isInitialized() ? 'Re' : '') + 'Load';
            perf.clear(key);
        }, this);
        this.backend.bind('oobLoaded', function sessionOOBLoaded (messages) {
            var prefix = this.isInitialized() ? 'Re' : '';
            var key = 'oob' + prefix + 'Load';
            var m = this.perfMeasure(key, null, {
                messages: messages.length
            });
            debug.log(key, m + 'ms');
            key = 'oob' + prefix + 'Process';
            debug.timeStamp(key);
            // debug.profile();
            perf.mark(key);
        }, this);
        this.bind('doneLoading', function sessionDoneLoading (inited) {
            var key = 'oob' + (inited ? 'Re' : '') + 'Process';
            var m = this.perfMeasure(key, null, {
                buffers: this.buffers.length
            });
            debug.log(key, m + 'ms');
            // debug.profileEnd();
            debug.timeStamp('backlog_complete');
        }, this);
        
        this.backend.bind('message', function sessionBackendMessage (message) {
            if (message.type && this.messageHandlers[message.type]) {
                this.messageHandlers[message.type].call(this, message);
            }
            if (message.cid) {
                this.trigger('connectionMessage:' + message.cid, message);
            }
            if (message.eid) {
                this.backend.setMaxEid(message.eid, this.isInitialized());
            }
        }, this);
        this.backend.bind('response', function sessionBackendResponse (response, reqest) {
            if (response.cid) {
                this.trigger('connectionResponse:' + response.cid, response, reqest);
            }
        }, this);
        this.backend.bind('connected', this.connected, this);
        this.backend.bind('offline', this.disconnected, this);
        this.backend.bind('streamError', this.disconnected, this);
        this.backend.bind('disconnect', this.disconnected, this);
        this.backend.bind('stream:stopped', this.disconnected, this);

        this.viewState = new ViewState(null, {
            session: this
        });
        
        this.orgs = new OrgList();
        this.orgs.on('change', this.orgsChange, this);
        this.orgs.on('remove', this.orgRemoved, this);
        
        this.files = new FileList(null, {
            session: this
        });
        this.pastebins = new PastebinList(null, {
            session: this
        });

        this.connections = new ConnectionList(null, {
            session: this
        });
        this.connections.bind('add', this.onAddConnection, this);
        this.connections.bind('remove', this.onRemoveConnection, this);
        this.connections.bind('urlPropChange', this.onChangeConnectionUrlProp, this);
        
        // Fuzzy connection map that will allow us to find a result for
        // connections supplied without disambiguation or port
        this.connectionIds = {};
        
        this.buffers = new BufferList();
        this.buffers.bind('change:last_seen_eid', this.updateSeenEidState, this);
        
        this.pinnedBuffers = new PinnedBufferList();

        this.unseenBuffers = new BufferList();
        this.buffers.bind('unseenChange unseenHighlightChange prefChange:disableTrackUnread', function (buffer) {
            if (buffer.hasUnseen() && (buffer.isTrackingUnread() || buffer.hasUnseenHighlights())) {
                this.unseenBuffers.add(buffer, {silent: true});
            } else {
                this.unseenBuffers.remove(buffer, {silent: true});
            }
            this.trigger('unseenChange');
        }, this);
        this.buffers.bind('remove', function (buffer) {
            buffer.stopListening();
            this.unseenBuffers.remove(buffer, {silent: true});
            this.trigger('unseenChange');
        }, this);
        
        this.previousBuffer = null;
        this.currentBuffer = null;
        
        this.focused = false;
        
        this.initialized = null;
        this.loading = null;
        this.backlogComplete = null;
        this.statUser = null;
    },
    perfMeasure: function (name, key, metadata, m) {
        m = m || perf.measure(name);
        var vals;
        var initial = metadata ? {vals: []} : [];
        if (key) {
            if (!this.timing[name]) {
                this.timing[name] = {};
            }
            if (!this.timing[name][key]) {
                this.timing[name][key] = initial;
            }
            vals = this.timing[name][key];
        } else {
            if (!this.timing[name]) {
                this.timing[name] = initial;
            }
            vals = this.timing[name];
        }
        if (metadata) {
            vals.vals.push(m);
            for (var k in metadata) {
                if (!vals[k]) {
                    vals[k] = [];
                }
                vals[k].push(metadata[k]);
            }
        } else {
            vals.push(m);
        }
        return m;
    },
    initiTimingStats: function () {
        if ('performance' in window) {
            if ('timing' in window.performance) {
                this.timing.timing = {
                    dns: window.performance.timing.domainLookupEnd - window.performance.timing.domainLookupStart,
                    connect: window.performance.timing.requestStart - window.performance.timing.connectStart,
                    response: window.performance.timing.responseEnd - window.performance.timing.requestStart,
                    dom: window.performance.timing.loadEventStart - window.performance.timing.domLoading,
                    setup: Date.now() - window.performance.timing.loadEventStart
                };
            }
            if ('navigation' in window.performance) {
                this.timing.navigation = {
                    redir: window.performance.navigation.redirectCount,
                    type: window.performance.navigation.type
                };
            }
        }
    },
    startClientStats: function () {
        this.perfEpoch = perf.ts();
        var initialWait = 5*60*1000;
        var interval = 30*60*1000;
        this.initiTimingStats();
        setTimeout(_.bind(function () {
            this.reportClientStats();
            this.reportClientStatsInterval = setInterval(_.bind(this.reportClientStats, this), interval);
        }, this), initialWait);
    },
    reportClientStats: function () {
        if ('performance' in window && 'memory' in window.performance) {
            this.timing.memory = _.clone(window.performance.memory);
            this.timing.memory.time = this.perfTs();
            var lastMemory = _.clone(this.timing.memory);
            if (this.lastMemory) {
                this.timing.memoryDelta = {};
                for (var k in this.lastMemory) {
                    this.timing.memoryDelta[k] = this.timing.memory[k] - this.lastMemory[k];
                }
            }
            this.lastMemory = lastMemory;
        }
        if (_.size(this.timing)) {
            var json = JSON.stringify(this.timing);
            if (this.featureCheck('clientStats')) {
                this.post("client-stats", {
                    ua: window.navigator.userAgent,
                    data: json
                });
            }
            this.timing = {};
        }
    },
    perfTs: function () {
        return perf.ts() - this.perfEpoch;
    },
    perfTime: function (name, key) {
        var vals = key ? this.timing[name][key] : this.timing[name];
        vals = vals.vals || vals;
        var sum = _.reduce(vals, function (memo, num) {
            return memo + num;
        }, 0);
        return sum / vals.length;
    },
    perfData: function (name, key, dataKey) {
        var vals = key ? this.timing[name][key] : this.timing[name];
        if (dataKey) {
            return vals[dataKey];
        } else {
            return vals;
        }
    },
    ent: function (prop) {
        if (window.Enterprise) {
            if (prop) {
                return window.Enterprise[prop];
            }
            return true;
        }
    },
    hasAutojoin: function () {
        if (!this.ent()) {
            return false;
        }
        if (this.get('autojoin_prattle') || this.get('autojoin_custom')) {
            return true;
        }
        return false;
    },
    getUser: function () {
        return this.user;
    },
    getAvatars: function (current) {
        var avatars = [];
        var avatars_seen = {};
        this.connections.each(function (c) {
            var a = c.getUser().getAvatar({strict: true});
            if (a && !a.external) {
                var seenIndex = avatars_seen[a.id];
                if (seenIndex !== undefined) {
                    avatars[seenIndex].connections.push(c);
                } else {
                    avatars_seen[a.id] = avatars.length;
                    avatars.push({
                        id: a.id,
                        template: a.src,
                        connections: [c]
                    });
                }
            }
        });
        // Add primary to the front of the list, but retain existing connections if shared
        var primary = this.getUser().getAvatar();
        if (primary) {
            var primary_a = {
                id: primary.id,
                template: primary.src,
                connections: []
            };
            if (avatars_seen[primary.id] !== undefined) {
                primary_a = avatars.splice(avatars_seen[primary.id], 1)[0];
            }
            primary_a.primary = true;
            avatars.unshift(primary_a);
        }
        // Move cid to the start
        if (current) {
            var idx = _.findIndex(avatars, function (a) {
                return a.id === current;
            });
            
            if (idx !== -1) {
                var currentA = avatars.splice(idx, 1)[0];
                avatars.unshift(currentA);
            }
        }
        return avatars;
    },
    getNick: function () {
        if (this.hasConnections()) {
            if (this.currentBuffer) {
                return this.currentBuffer.getNick();
            } else if (this.previousBuffer) {
                return this.previousBuffer.getNick();
            } else {
                return this.connections.at(0).getNick();
            }
        } else {
            if (this.get('name')) {
                return this.get('name').split(' ')[0].toLowerCase();
            } else {
                return this.get('email').split('@')[0].toLowerCase();
            }
        }
    },
    isSSBFluid: function () {
        return !!window.fluid;
    },
    isDesktop: function () {
        return !!window.IRCCLOUD_DESKTOP_VERSION || !!window.IRCCLOUD_ELECTRON;
    },
    isFocused: function () {
        return this.focused;
    },
    setFocused: function (value) {
        this.focused = value;
        this.trigger('focusChange');
    },
    tempPostMessageWhitelist: {},
    tempPostMessageWhitelistId: 1,
    postMessageTempWhitelist: function (whitelistOrigin) {
        var tempId = this.tempPostMessageWhitelistId++;
        this.tempPostMessageWhitelist[tempId] = whitelistOrigin;
        return tempId;
    },
    cleanMessageTempWhitelist: function (whitelistOriginId) {
        if (whitelistOriginId) {
            delete this.tempPostMessageWhitelist[whitelistOriginId];
        }
    },
    addPostMessage: function (event) {
        var whitelist = [
            this.getOrigin(),
            window.API_HOST,
            'https://www.instagram.com',
            'https://imgur.com',
            'https://platform.twitter.com',
            'https://gfycat.com',
            'https://embed.reddit.com',
            'https://embed.bsky.app'
        ].concat(Object.values(this.tempPostMessageWhitelist));
        if (!_.contains(whitelist, event.origin)) {
            return;
        }
        // Skip certain events we don't care about
        if (
            event.origin === 'https://platform.twitter.com' &&
            _.isString(event.data) &&
            event.data.indexOf('{"settings":') === 0
        ) {
            return;
        }
        this.postMessages.push(event);
        this.trigger('postMessage', event);
    },
    findMessage: function (filter, timeout, whitelistOriginId) {
        var complete = $.Deferred();
        var m = this._findMessage(filter);
        var cleanup;
        if (m) {
            complete.resolve(m);
            this.cleanMessageTempWhitelist(whitelistOriginId);
        } else {
            var onPostMessage = _.bind(function () {
                var m = this._findMessage(filter);
                if (m) {
                    complete.resolve(m);
                }
            }, this);
            cleanup = _.bind(function () {
                this.unbind('postMessage', onPostMessage);
                this.cleanMessageTempWhitelist(whitelistOriginId);
            }, this);
            complete.always(cleanup);
            this.bind('postMessage', onPostMessage);
            if (timeout) {
                setTimeout(_.bind(function () {
                    complete.reject();
                }, this), timeout);
            }
        }
        var promise = complete.promise();
        promise.cleanup = cleanup;
        return complete.promise();
    },
    _findMessage: function (filter) {
        var match;
        var toDelete = [];
        _.find(this.postMessages, function (m, i) {
            var ret = filter(m);
            if (ret) {
                match = (ret === true) ? m : ret;
                toDelete.push(i);
                return true;
            }
            if (ret === null) {
                toDelete.push(i);
            }
            return false;
        }, this);
        _.each(toDelete, function (i, ii) {
            this.postMessages.splice(i - ii, 1);
        }, this);
        return match;
    },
    getLastSelectedBuffer: function () {
        return this.buffers.get(this.get('last_selected_bid'));
    },
    selectPreviousBuffer: function (options) {
        if (this.previousBuffer) {
            this.previousBuffer.select(options);
            return true;
        }
        return false;
    },
    markAllAsRead: function () {
        this.buffers.invoke('read');
    },
    clearCurrentBuffer: function (silent) {
        this.setCurrentBuffer(null, {
            silent: silent,
            cleared: true
        });
    },
    setThreadId: function (threadId, options) {
        options = options || {};
        this.threadId = threadId;
        if (!options.silent) {
            this.trigger('threadChange');
        }
    },
    clearThreadId: function () {
        this.setThreadId(null);
    },
    setCurrentBuffer: function (buffer, options) {
        options = options || {};
        if (this.currentBuffer != buffer) {
            this.previousBuffer = this.currentBuffer;
            
            if (this.previousBuffer) {
                this.previousBuffer.deselect();
            }
            
            if (buffer) {
                this.currentBuffer = buffer;
                this.set({'last_selected_bid': this.currentBuffer.bid()});
            } else {
                this.currentBuffer = null;
            }
            
            if (!options.silent) {
                this.trigger('currentBufferChange', {
                    cleared: options.cleared,
                    replace: options.replace
                });
            }
        }
    },
    updateSeenEidState: function (buffer) {
        this.viewState.updateSeenEid(buffer);
    },
    bufferSelectedChange: function (buffer, options) {
        this.setCurrentBuffer(buffer, options);
    },
    addBuffer: function (buffer) {
        if (this.isReloading()) {
            delete this.buffersToDeactivate[buffer.bid()];
        }
        
        this.buffers.add(buffer);
        buffer.connection.buffers.bind('remove', function (buf) {
            if (buf == buffer) {
                if (this.previousBuffer == buffer) {
                    this.previousBuffer = null;
                }
                this.buffers.remove(buffer);
                this.pinnedBuffers.unpin(buffer);
            }
        }, this);
        // Remove when connection is removed
        buffer.connection.bind('remove', function () {
            if (this.previousBuffer == buffer) {
                this.previousBuffer = null;
            }
            this.buffers.remove(buffer);
            this.pinnedBuffers.unpin(buffer);
        }, this);
    },
    getConnectionById: function (connectionId) {
        return this.connectionIds[connectionId.toLowerCase()];
    },
    setConnectionIds: function (connection) {
        // Disambiguate
        var disambiguation = 0;
        while (this.connectionIds[connection.testId(disambiguation)]) {
            disambiguation++;
        }
        connection.setDisambiguation(disambiguation);
        
        // Set some fuzzy shortcuts
        var keys = connection.getIdKeys();
        _.each(keys, function (key, i) {
            // Only if this shortcut isn't already taken
            if (!this.connectionIds[key]) {
                this.connectionIds[key] = connection;
            }
        }, this);
        if (connection.isSelected()) {
            this.trigger('currentConnectionUrlChange');
        }
    },
    removeConnectionIds: function (connection) {
        // Remove fuzzy shortcuts
        for (var key in this.connectionIds) {
            if (this.connectionIds[key] == connection) {
                delete this.connectionIds[key];
            }
        }
    },
    onAddConnection: function (connection) {
        // Bind message events by cid
        connection.bindMessages();

        // Maintain separate this.buffers list
        connection.buffers.bind('add', this.addBuffer, this);
        this.setConnectionIds(connection);
    },
    onRemoveConnection: function (connection) {
        this.removeConnectionIds(connection);
    },
    onChangeConnectionUrlProp: function (connection) {
        this.removeConnectionIds(connection);
        this.setConnectionIds(connection);
    },
    isLoading: function () {
        return this.loading;
    },
    numActiveConnections: function () {
        return this.connections.filter(function (c) {
            if (!c.isWhitelisted() && c.isActive()) {
                return true;
            }
        }).length;
    },
    clearFocusOnMakes: function () {
        this.connections.each(function (c) {
            c.setFocusOnMakeBuffer(null);
        });
        this.setFocusOnMakeServer(null);
    },
    setFocusOnMakeServer: function (cid) {
        this.focusOnMakeServer = cid;
        var connection = this.getConnection(cid);
        if (connection) {
            this.checkFocusOnMakeServer(connection);
        }
    },
    checkFocusOnMakeServer: function (connection) {
        if (this.focusOnMakeServer == connection.getCid()) {
            this.setFocusOnMakeServer(null);
            connection.setFocusOnMakeBuffer('*');
        }
    },
    addConnection: function (data) {
        var connection = new Connection(data, {
            session: this
        });
        this.connections.add(connection);
        return connection;
    },
    logout: function () {
        this.loggingOut = true;
        var form = $('<form action="" method="post">').attr('action', this.backend.buildUrl("/logout"));
        form.append($('<input type="hidden">').attr({
            name: 'session',
            value: this.getAuthCookie()
        }));
        $('body').append(form);
        form.submit();
    },
    messageHandlers: {
        global_system_message: function (message) {
            if (this.isBacklogLoaded()) {
                if (message.system_message_type == 'eval') {
                    eval(message.msg);
                } else {
                    this.trigger('systemMessage', message);
                }
            }
        },
        database_status: function (message) {
            this.set('database_status', message.status);
        },
        // Happens on logout in another tab
        session_deleted: function (message) {
            if (!this.loggingOut) {
                this.doLogout();
            }
        },
        // Can happen if we have too many streams open and the server
        // wants us to disconnect without auto-retrying
        shutdown: function (message) {
            debug.info("Server told us to shutdown: " + message.msg);
            this.stopBackend();
        },
        stat_user: function (message) {
            this.set(message);
            this.trigger('stat');
            if (this.backlogComplete && !this.statUser) {
                // Only happens the first time, if stat_user arrives after backlog_complete
                this.init();
            }

            if (this.postStatUrl) {
                this.trigger('navigate', this.postStatUrl);
                this.postStatUrl = null;
            }
            this.statUser = true;
        },
        num_invites: function (message) {
            this.set({num_invites: message.num_invites});
        },
        sys_msgs: function (message) {
            this.setZombie(message);
        },
        heartbeat_echo: function (message) {
            var cid, bid, connection, buffer;
            var seenEids = message.seenEids;
            // Update seenEids
            for (cid in seenEids) {
                connection = this.getConnection(cid);
                if (!connection) {
                    // Connection may have been deleted
                    continue;
                }
                for (bid in seenEids[cid]) {
                    buffer = connection.getBuffer(bid);
                    if (!buffer) {
                        // Buffer may have been deleted
                        continue;
                    }
                    if (buffer.isMessageUnseen(seenEids[cid][bid])) {
                        buffer.setLastSeen(seenEids[cid][bid]);
                    }
                }
            }
        },
        makeserver: function (message) {
            var connection = this.getConnection(message.cid);
            if (connection) {
                connection.reload(message);
            } else {
                connection = this.addConnection(message);
                this.checkFocusOnMakeServer(connection);
            }
            // Track recreated/active servers, so we can delete/deactivate remainders after the backlog completes
            if (this.isReloading()) {
                delete this.connectionsToDelete[connection.getCid()];
            }
        },
        makebuffer: function (message) {
            // Track recreated buffers, so we can delete remainders after the backlog completes
            if (this.isReloading() && this.buffersToDelete[message.cid]) {
                delete this.buffersToDelete[message.cid][message.bid];
            }
        },
        connection_deleted: function (message) {
            this.removeConnection(message.cid);
        },
        reorder_connections: function (message) {
            this.connections.orderChanged(message.order);
        },
        export_finished: function (message) {
            this.trigger('exportFinished', message);
        },
        backlog_complete: function (message) {
            var inited = this.isInitialized();
            if (inited) {
                // Happens every subsequent time a stream reconnects
                // only diff/remove buffers if we got an entirely fresh
                // set of backlog (not if we resumed via streamid)
                if (!message.resumed) {
                    this.updateRemainderBufferState();
                }
            } else {
                // Only happens the first time
                if (this.statUser && !this.backlogComplete) {
                    this.init();
                    // Start heartbeat and client stats
                    this.viewState.startHeartbeat();
                    this.startClientStats();
                }
                this.backlogComplete = true;
            }
            this.loading = false;
            this.trigger('doneLoading', inited);
        }
    },
    getStreamId: function () {
        return this.backend.streamId;
    },
    init: function () {
        this.setRavenContext();
        this.initialized = true;
        if (!this.ent()) {
            this.getPlans();
        }
        this.pinnedBuffers.onChange();
        this.bind('prefChange:pinnedBuffers', this.onPinnedBufferChange, this);
        this.trigger('init');
    },
    setRavenContext: function () {
        if (!this.ent() && window._Raven) {
            window._Raven.ready('setUserContext', [{
                email: this.get('email'),
                id: this.id
            }]);
        }
    },
    removeConnection: function (cid) {
        var connection = this.getConnection(cid);
        // We can get these again in the case of resuming a buffer after no message
        // has arrived after it to bump the since_id past it.
        if (connection) {
            connection.set({removing: true}, {silent: true});
            connection.removeChildren();
            this.trigger('beforeConnectionRemove', connection);
            this.connections.remove(cid);
            connection.stopListening();
        }
    },
    getConnection: function (cid) {
        return this.connections.get(cid);
    },
    findOrgConn: function (orgId) {
        return this.connections.find(function (c) {
            return c.get('orgid') == orgId && !c.get('removing');
        });
    },
    findTeamConn: function (orgId) {
        return this.connections.find(function (c) {
            return c.get('team_server') === true && !c.get('removing');
        });
    },
    findMatchingConnections: function (hostname) {
        return this.connections.filter(function (c) {
            return c.getHostname() == hostname.toLowerCase() && !c.get('removing');
        });
    },
    isInitialized: function () {
        return !!this.initialized;
    },
    isDbDown: function () {
        return this.get('database_status') == 'down';
    },
    setXhrFallback: function () {
        this.xhrFallback = true;
    },
    isXhrFallback: function () {
        return !!this.xhrFallback;
    },
    isBacklogLoaded: function () {
        return this.isInitialized() && !this.isLoading();
    },
    isReloading: function () {
        return this.isInitialized() && this.isLoading();
    },
    connected: function () {
        this.loading = true;
        if (this.isInitialized()) {
            this.trackBufferState();
        }
        this.setStreamConnected(true);
    },
    disconnected: function () {
        this.setStreamConnected(false);
    },
    setStreamConnected: function (value) {
        if (this.streamConnected != value) {
            this.streamConnected = value;
            this.trigger('streamConnectedChange');
        }
    },
    isStreamConnected: function () {
        return this.streamConnected;
    },
    trackBufferState: function () {
        // Start tracking the buffers that get created so we can delete any remainders
        // that might have been removed while we were disconnected from the sctream
        // this happens in updateRemainderBufferState at backlog_complete
        this.buffersToDelete = {};
        this.buffersToDeactivate = {};
        this.connectionsToDelete = {};
        this.connections.each(function (connection) {
            this.connectionsToDelete[connection.getCid()] = connection;
            this.buffersToDelete[connection.getCid()] = {};
            this.buffersToDeactivate[connection.getCid()] = {};
        }, this);
        this.buffers.each(function (buffer) {
            this.buffersToDelete[buffer.getCid()][buffer.bid()] = buffer;
            this.buffersToDeactivate[buffer.getCid()][buffer.bid()] = buffer;
        }, this);
    },
    updateRemainderBufferState: function () {
        // Connections/buffers have now had the chance to remove themselves from the
        // ToDelete/Deactivate lists, so we can process those now
        var cid, bid;
        for (cid in this.connectionsToDelete) {
            this.removeConnection(this.connectionsToDelete[cid]);
            // We won't need to deactivate this connection
            // or delete/deactivate its buffers
            delete this.buffersToDelete[cid];
            delete this.buffersToDeactivate[cid];
        }
        
        for (cid in this.buffersToDelete) {
            for (bid in this.buffersToDelete[cid]) {
                var connection = this.getConnection(cid);
                if (connection) {
                    connection.removeBuffer(bid);
                }
                // We won't need to deactivate this buffer
                if (this.buffersToDeactivate[cid]) {
                    delete this.buffersToDeactivate[cid][bid];
                }
            }
        }
        for (cid in this.buffersToDeactivate) {
            for (bid in this.buffersToDeactivate[cid][bid]) {
                this.buffersToDeactivate[cid][bid].deactivate();
            }
        }
    },
    doSetPinnedBuffer: function (buffer, enable, idx) {
        if (enable) {
            if (!this.isPinnedBuffer(buffer)) {
                buffer.trigger('beforePinnedChange', buffer);
                if (idx === undefined) {
                    this.pinnedBuffers.addAtEnd(buffer);
                } else {
                    this.pinnedBuffers.addAt(buffer, idx);
                }
                buffer.trigger('pinnedChange', buffer);
            }
        } else {
            if (this.isPinnedBuffer(buffer)) {
                buffer.trigger('beforePinnedChange', buffer);
                this.pinnedBuffers.unpin(buffer);
                buffer.trigger('pinnedChange', buffer);
            }
        }
    },
    setPinnedBuffer: function (buffer, enable) {
        this.doSetPinnedBuffer(buffer, enable);
        this.pinnedBuffers.onChange();
        this.setPref('pinnedBuffers', this.pinnedBuffers.bids());
    },
    onPinnedBufferChange: function () {
        var bids = this.getPref('pinnedBuffers') || [];
        this.resetPinnedBuffers(bids);

    },
    resetPinnedBuffers: function (bids) {
        var oldPinnedBuffers = this.pinnedBuffers.clone();
        oldPinnedBuffers.each(function (b) {
            var newIdx = _.indexOf(b.id, bids);
            if (newIdx !== b.pinned) {
                this.doSetPinnedBuffer(b, false);
            }
        }, this);
        _.each(bids, function (bid, idx) {
            var buffer = this.buffers.get(bid);
            if (buffer && !this.isPinnedBuffer(buffer)) {
                this.doSetPinnedBuffer(buffer, true, idx);
            }
        }, this);
        this.pinnedBuffers.onChange();
    },
    setPinnedOrder: function (bids) {
        this.setPref('pinnedBuffers', bids);
    },
    getPinnedIdx: function (bid) {
        return _.indexOf(this.getPref('pinnedBuffers') || [], bid);
    },
    addPinnedBuffer: function (buffer) {
        var pinnedIdx = this.getPinnedIdx(buffer.id);
        if (pinnedIdx !== -1) {
            this.pinnedBuffers.addAt(buffer, pinnedIdx);
        }
    },
    isPinnedBuffer: function (buffer) {
        return this.pinnedBuffers.isPinned(buffer);
    },
    isPinnedBufferAmbiguous: function (buffer) {
        if (this.isPinnedBuffer(buffer) && this.pinnedBuffers.isAmbiguous(buffer)) {
            return true;
        }
        return false;
    },
    hasPinnedBuffers: function () {
        return !this.pinnedBuffers.isEmpty();
    },
    
    getAuthCookie: function () {
        return this.getCookie('session');
    },
    getAuth: function () {
        return this.get('session');
    },
    getHighlights: function () {
        return this.get('highlights') || [];
    },
    unsupported: function () {
        this.supported = false;
        this.setStreamConnected(false);
    },
    isSupported: function () {
        return this.supported;
    },
    isAuthed: function () {
        return !!this.getAuth();
    },
    setUser: function () {
        this.user = new User({
            email: this.get('email'),
            realname: this.get('name'),
            avatar: this.get('avatar')
        }, {
            session: this
        });
    },
    
    // Cookie helpers
    setCookie: function (name, value, days, deleting) {
        var expires;
        if (days) {
            var date = new Date();
            var seconds = days*24*60*60;
            date.setTime(date.getTime() + (seconds*1000));
            expires = "; Expires=" + date.toGMTString() + '; Max-Age=' + seconds;
        } else {
            expires = "";
        }
        var cook = name + "=" + value + "; Version=1" + expires + "; Path=/";
        if (this.isSecure()) {
            cook += "; Secure";
        }
        cook += "; SameSite=Lax";
        var domain = this.getHost();
        var domainCook = cook + "; Domain=" + domain;
        if (deleting) {
            document.cookie = cook;
            var rootDomain = domain.split('.').slice(-2).join('.');
            if (rootDomain != domain) {
                var rootDomainCook = cook + "; Domain=" + rootDomain;
                document.cookie = rootDomainCook;
            }
        }
        document.cookie = domainCook;

    },
    getCookie: function (name) {
        var namekey = name + "=";
        var cookies = document.cookie.split(';');
        for (var i = 0; i < cookies.length;i++) {
            var c = cookies[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1, c.length);
            }
            if (c.indexOf(namekey) === 0) {
                return c.substring(namekey.length, c.length);
            }
        }
        return null;
    },
    deleteCookie: function (name) {
        this.setCookie(name, "", -1, true);
    },
    
    // Backend control
    startBackend: function () {
        this.backend.start();
    },
    stopBackend: function () {
        this.backend.stop();
    },
    doLogout: function () {
        this.loggingOut = true;
        this.deleteCookie('session');
        this.deleteCookie('invite');
        this.refresh();
    },
    noAuth: function () {
        if (window.IRCConfig.disable_signups) {
            this.doLogout();
        } else {
            this.deleteCookie('session');
            this.trigger('noAuth');
        }
    },
    setShard: function (message) {
        this.set({
            shard_id: message.shard_id,
            shard_name: message.shard_name
        });
        window.WS_SOCKET_HOST = message.websocket_host;
        window.WS_SOCKET_PATH = message.websocket_path;
        window.API_HOST = message.api_host;
        // Cookie is updated already by Set-Cookie header if not using a cross domain
        // web socket
        if (this.backend.isXDSocket()) {
            this.setAuthCookie(message.cookie);
        }
        this.startCookie();
    },
    
    // Host helpers
    getHost: function () {
        return window.location.hostname;
    },
    getLocation: function () {
        return window.location;
    },
    getOrigin: function () {
        return window.location.origin;
    },
    isSecure: function () {
        return window.location.protocol === 'https:';
    },
    redirect: function (url) {
        Backbone.history.stop();
        window.location = url;
        window.location.reload();
    },
    refresh: function () {
        Backbone.history.stop();
        if (/^\/((irc\/)|$)/.test(window.location.pathname)) {
            window.location.reload();
        } else {
            window.location.pathname = '/';
        }
    },
    
    processOrgs: function () {
        this.orgs.set(this.get('orgs'), {
            session: this,
            silent: true
        });
        this.orgs.invoke('parseConnections');
        this.orgsChange();
    },
    orgsChange: function () {
        this.trigger('orgsChange');
    },
    orgRemoved: function (org) {
        org.stopListening();
    },
    // Prefs
    parsePrefs: function () {
        var previousPrefs = $.extend(true, {}, this.prefs);
        this.prefs = {};
        if (this.get('prefs')) {
            try {
                // Extend this.prefs in place
                var prefs = JSON.parse(this.get('prefs'));
                $.extend(true, this.prefs, prefs);
            } catch (e) {
                debug.warn('invalid prefs blob', this.get('prefs'));
            }
        }
        var changes = {};
        for (var k in $.extend(true, {}, previousPrefs, this.prefs)) {
            if (!_.isEqual(this.prefs[k], previousPrefs[k])) {
                this.trigger('prefChange:' + k, previousPrefs[k]);
                changes[k] = previousPrefs[k];
            }
        }
        if (!$.isEmptyObject(changes)) {
            this.trigger('prefChange', changes);
        }
    },
    getPref: function (key, defaultValue) {
        return this.prefs[key] || defaultValue;
    },
    setPref: function (key, value) {
        var prefs;
        // Single arg means full pref object
        if (arguments.length === 2) {
            prefs = {};
            prefs[key] = value;
        } else {
            prefs = key;
        }
        var previousValue;
        var v;
        var newPrefs = $.extend(true, {}, this.prefs);
        for (var k in prefs) {
            v = prefs[k];
            previousValue = newPrefs[k];
            if (v) {
                if (!_.isEqual(v, previousValue)) {
                    newPrefs[k] = v;
                }
            } else {
                if (previousValue) {
                    delete newPrefs[k];
                }
            }
        }
        this.savePrefs(newPrefs);
    },
    savePrefs: function (prefs) {
        this.set({prefs: JSON.stringify(prefs)});
        this.post('set-prefs', {
            prefs: this.get('prefs')
        });
    },

    modifierMeEnabled: function () {
        return !this.getPref('keyboard-disable-modifier-me');
    },
    setModifierMe: function (value) {
        this.setPref('keyboard-disable-modifier-me', !value);
    },
    setPastebinPrompts: function (value) {
        this.setPref('pastebin-disableprompt', !value);
    },
    shouldPromptPastebins: function () {
        return !this.getPref('pastebin-disableprompt');
    },
    avatarsEnabled: function () {
        return !this.getPref('avatars-off');
    },
    imageAvatarsEnabled: function () {
        return this.avatarsEnabled() && !this.getPref('avatars-image-off');
    },
    embedExternalAvatars: function () {
        return this.imageAvatarsEnabled() && this.getPref('inlineimages');
    },
    
    // Actions
    start: function () {
        if (this.started) {
            debug.warn('Trying to start Session again');
        } else {
            this.started = true;
            this.trigger('start');
            this.backend.init();
            if (this.isSupported()) {
                this.startCookie();
            }
        }
    },
    registerServiceWorker: function () {
        if ('serviceWorker' in navigator) {
            window.addEventListener('load', function() {
                navigator.serviceWorker.register('/sw.js').then(function(registration) {
                    // Registration was successful
                }, function(err) {
                    debug.warn('ServiceWorker registration failed: ', err);
                });
            });
        }
    },
    startCookie: function () {
        this.startSession(this.getAuthCookie());
    },
    startRefresh: function (session, url) {
        // Cookie is updated already by Set-Cookie header if not
        // using a cross domain API domain
        if (this.backend.isXDAPI()) {
            this.setAuthCookie(session);
        }
        if (url) {
            this.redirect(url);
        } else {
            this.refresh();
        }
    },
    setAuthCookie: function (session) {
        this.setCookie('session', session, 100);
    },
    startSession: function (session, url) {
        if (session) {
            // Cookie is updated already by Set-Cookie header if not
            // using a cross domain API domain
            if (this.backend.isXDAPI()) {
                this.setAuthCookie(session);
            }
            this.set({session: session});
            this.startBackend();
            this.postStatUrl = url;
        } else {
            this.noAuth();
        }
    },
    resendVerifyEmail: function (callback) {
        this.post("resend-verify-email", {}, callback);
    },
    authFormToken: function (method, data, callback, options) {
        this.backend.post("auth-formtoken", {}, _.bind(function (response) {
            if (response.success) {
                data.token = response.token;
                this.backend.post(method, data, callback, {
                    headers: {
                        'x-auth-formtoken': response.token
                    }
                }, options);
            } else {
                callback(response);
            }
        }, this));
    },
    forgotPassword: function (email, callback) {
        this.authFormToken("request-password-reset", {
            email: email
        }, callback, {
            urlHost: this.getOrigin()
        });
    },
    signin: function (data, callback) {
        this.authFormToken("login", data, callback, {
            urlHost: this.getOrigin()
        });
    },
    signup: function (data, callback) {
        this.authFormToken("signup", data, callback, {
            urlHost: this.getOrigin()
        });
    },
    changeCredentials: function (oldpassword, newpassword, email, callback) {
        this.post("change-password", {
            password: oldpassword,
            newpassword: newpassword,
            email: email
        }, callback);
    },
    deleteAccount: function (password, callback) {
        this.loggingOut = true;
        this.post("delete-account", {
            password: password
        }, _.bind(function (response) {
            if (response.success) {
                this.trigger('navigate', '?/account-deleted');
                this.doLogout();
            } else {
                this.loggingOut = false;
            }
            if (callback) {
                callback(response);
            }
        }, this));
    },
    userSettings: function (realname, hwords, autoaway, callback) {
        var data = {
            realname: realname,
            hwords: hwords
        };
        if (autoaway) {
            data['autoaway'] = '1';
        }
        this.post("user-settings", data, callback);
    },
    exportLogs: function (options, callback) {
        options = options || {};
        var model = options.model;
        var data = {
            timezone: options.timezone
        };

        if (model instanceof Buf) {
            data.bid = model.bid();
            data.cid = model.getCid();
        } else if (model instanceof Connection) {
            data.cid = model.getCid();
        }

        this.post("export-log", data, callback);
    },
    sendInvite: function (emails, callback) {
        this.post("send-invite", {
            emails: emails
        }, callback);
    },
    hasConnections: function () {
        return !!this.connections.reject(function (c) {
            return !!c.get('removing');
        }).length;
    },
    hasActiveOrgs: function () {
        if (!this.orgs.length) {
            return false;
        }
        return !!this.orgs.find(function (o) {
            return o.hasActiveSubscription();
        });
    },
    hasOneOrg: function () {
        return this.orgs.length == 1;
    },
    createOrg: function (data, callback) {
        this.post('create-org', data, callback);
    },
    removeOrg: function (org, callback) {
        this.post('delete-org', {
            org: org.id
        }, callback);
    },
    leaveOrg: function (org, callback) {
        this.post('leave-org', {
            org: org.id
        }, callback);
    },
    joinOrg: function (data, callback) {
        this.post('join-org', data, callback);
    },
    joinDefaultConnections: function (data, callback) {
        this.post('join-default-connections', data, callback);
    },
    previousRoute: null,
    currentRoute: null,
    onRoute: function (route, args) {
        this.previousRoute = this.currentRoute;
        this.currentRoute = [route, args];
    },
    back: function () {
        if (this.previousRoute) {
            Backbone.history.history.back();
        } else {
            this.trigger('navigate', '', {replace: true});
        }
    },
    addNetwork: function (data, callback) {
        this.post("add-server", data, callback);
    },
    joinDefault: function (nickname, realname, callback) {
        this.post("add-default-server", {
            nickname: nickname,
            realname: realname
        }, callback);
    },
    getBackoff: function (endpoint, data, delay, failCount, complete) {
        complete = complete || $.Deferred();
        data = data || {};
        this.backend.get(endpoint, data, _.bind(function (response) {
            if (response.error || response.success === false) {
                if (
                    failCount >= 10 ||
                    response.message == 'not_found' ||
                    response.message == 'auth' ||
                    response.message == 'database_down' ||
                    complete.state() == 'rejected'
                ) {
                    complete.reject(response, {
                        failCount: failCount,
                        gave_up: true
                    });
                } else {
                    if (delay) {
                        delay *= 2;
                        if (delay > 5000) {
                            delay = 5000;
                        }
                    } else {
                        delay = 500;
                    }
                    if (failCount) {
                        failCount++;
                    } else {
                        failCount = 1;
                    }
                    complete.notify(response, {
                        failCount: failCount,
                        retry_delay: delay
                    });
                    setTimeout(_.bind(function () {
                        this.getBackoff(endpoint, data, delay, failCount, complete);
                    }, this), delay);
                }
            } else {
                complete.resolve(response);
            }
        }, this));
        return complete;
    },
    getExports: function (callback) {
        return this.backend.get('log-exports', {}, _.bind(function (response) {
            callback(response);
        }, this));
    },
    getSessions: function (callback) {
        return this.backend.get('sessions', {}, _.bind(function (response) {
            callback(response);
        }, this));
    },
    getStreams: function (callback) {
        return this.backend.get('streams', {
            stream_id: this.getStreamId()
        }, _.bind(function (response) {
            callback(response);
        }, this));
    },
    getPlans: function () {
        var complete = this.getBackoff('plans');
        return complete.promise().done(_.bind(function (response) {
            this.plans = response;
            this.trigger('plansChange');
        }, this));
    },
    getCurrency: function () {
        return this.plans.currency || 'usd';
    },
    getNetworks: function (callback) {
        $.getJSON('/static/networks.json', callback);
    },
    getOrgInviteConnections: function (inviteKey, callback) {
        this.backend.get('org-invite-connections', {
            org_invite: inviteKey
        }, callback);
    },
    
    // Feature flags
    featureOn: function (feature) {
        this.setFeature(feature, true);
    },
    featureOff: function (feature) {
        this.setFeature(feature, false);
    },
    setFeature: function (feature, value) {
        if (!window['FEATURES']) {
            window.FEATURES = {};
        }
        if (!_.isEqual(!!window.FEATURES[feature], value)) {
            window.FEATURES[feature] = value;
            this.trigger('featureChange');
            this.trigger('featureChange:' + feature);
        }
    },
    featureCheck: function (feature) {
        if (!window['FEATURES']) {
            return false;
        }
        return window.FEATURES[feature] || false;
    },
    
    checkSubPref: function (subPrefKey, key) {
        var subPref = this.getPref(subPrefKey);
        if (!_.isObject(subPref)) {
            subPref = {};
        }
        return subPref[key] || false;
    },
    setSubPref: function (subPrefKey, key, value) {
        var subPref = $.extend(true, {}, this.getPref(subPrefKey));
        if (value) {
            subPref[key] = value;
        } else {
            delete subPref[key];
        }
        if ($.isEmptyObject(subPref)) {
            subPref = false;
        }
        this.setPref(subPrefKey, subPref);
    },
    
    hasBeenPrompted: function (prompt) {
        return this.checkSubPref('prompts', prompt);
    },
    setPrompted: function (prompt) {
        this.setSubPref('prompts', prompt, true);
    },
    
    bncEnabled: function () {
        return this.featureCheck('bnc');
    },

    labCheck: function (lab) {
        return this.checkSubPref('labs', lab);
    },
    setLabs: function (labs) {
        for (var lab in labs) {
            this.setLab(lab, labs[lab]);
        }
    },
    setLab: function (lab, value) {
        this.setSubPref('labs', lab, value);
    },
    enableLab: function (lab) {
        this.setLab(lab, true);
    },
    disableLab: function (lab) {
        this.setLab(lab, false);
    },
    
    isAdmin: function () {
        return !!this.get('admin');
    },
    uploadsEnabled: function() {
        return !window.IRCConfig.file_uploads_disabled;
    },
    getJoinDate: function () {
        return this.get('join_date') && new Date(this.get('join_date') * 1000);
    },
    isLightTheme: function () {
        return this.getTheme() === 'dawn';
    },
    getTheme: function (defaultValue) {
        var theme = this.getPref('theme') || defaultValue || 'dawn';
        if (this.getPref('theme-auto')) {
            if (window.matchMedia('(prefers-color-scheme: dark)').matches) {
                return this.getDefaultDarkTheme();
            } else {
                return 'dawn';
            }
        }
        return theme;
    },
    getDefaultDarkTheme: function () {
        var theme = this.getPref('theme') || 'dawn';
        if (theme == 'dawn') {
            return 'dusk';
        } else {
            return theme;
        }
    },
    getFont: function () {
        return this.getPref('font') || 'sans';
    },
    joinedBeforeDate: function (date) {
        var joinDate = this.getJoinDate();
        if (!joinDate) {
            return null;
        }
        return joinDate.isBefore(date);
    },
    joinedAfterDate: function (date) {
        var joinDate = this.getJoinDate();
        if (!joinDate) {
            return null;
        }
        return joinDate.isAfter(date);
    },
    joinedBeforeDays: function (days) {
        var joinDate = this.getJoinDate();
        if (!joinDate) {
            return null;
        }
        return joinDate.isBefore(new Date().addDays(-days));
    },
    trialEnds: function () {
        // Make everyone's trial join date the release date
        var releaseDate = 1383580911; // Mon Nov 04 2013 16:01:51 GMT+0000 (GMT)
        var joinDate = new Date(Math.max(this.get('join_date') || 0, releaseDate) * 1000);
        return joinDate.addDays(this.get('trial_length'));
    },
    isVerified: function () {
        return this.get('verified');
    },
    post: function (method, data, callback) {
        return this.backend.streamPost(method, data, callback);
    },
    ajax: function (options, successTest, errorTest) {
        var httpMethod = options.type || 'get';
        var outLogLine = '-> [' + httpMethod.toUpperCase() + ']';
        var inLogLine = '<- [' + httpMethod.toUpperCase() + ']';
        if (!options.silent) {
            debug.log(outLogLine, options.url, options.data);
        }
        var inArgs = [options.url];
        if (options.data) {
            if (!(options.data instanceof FormData)) {
                inArgs.push($.param(options.data));
            }
            inArgs.push(options.data);
        }
        var filter = $.Deferred();
        options.xhr = options.xhr || function () {
            var xhr = $.ajaxSettings.xhr();
            if (xhr.upload) {
                xhr.upload.onprogress = function (e) {
                    filter.notify('upload', e);
                };
            }
            xhr.onprogress = function (e) {
                filter.notify('download', e);
            };
            return xhr;
        };
        var ajax = $.ajax(options);
        ajax.then(function(response, status, jqXHR) {
            if (!successTest) {
                filter.resolve(response, status, jqXHR);
            } else {
                var result = successTest(response, status, jqXHR);
                if (result === true) {
                    filter.resolve(response, status, jqXHR);
                } else if (result) {
                    filter.resolve(result, status, jqXHR);
                } else {
                    filter.reject(jqXHR, jqXHR.status, response);
                }
            }
            return filter.promise();
        }, function (jqXHR, errorString, errorThrown) {
            var response = options.dataType === 'json' ? jqXHR.responseJSON : jqXHR.responseText;
            if (!errorTest || errorTest(jqXHR, errorString, errorThrown)) {
                filter.reject(jqXHR, errorString, response, errorThrown);
            } else {
                filter.resolve(response, jqXHR.status, jqXHR);
            }
            return filter.promise();
        }).done(function (response, status, jqXHR) {
            if (status == 'success') {
                if (!options.silent) {
                    debug.log(inLogLine, inArgs, response);
                }
            } else {
                debug.log(inLogLine, inArgs, status, response);
            }
        }).fail(function (jqXHR, errorString, response, errorThrown) {
            debug.log(inLogLine, inArgs, errorString, errorThrown, jqXHR.status, response);
        }).catch(function (jqXHR, errorString, response, errorThrown) {
            debug.log(inLogLine, inArgs, errorString, errorThrown, jqXHR.status, response);
        });
        var promise = filter.promise();
        promise.ajax = ajax;
        return promise;
    },

    // BillingMixins
    subscribeUrl: 'subscribe-solo-stripe',
    billingInfoUrl: 'solo-billing',
    billingInfoParams: function () {
        return {};
    },
    updateCustomerUrl: 'update-solo-stripe-customer',
    reinstateSubscriptionUrl: 'reinstate-solo-subscription',
    cancelStripeSubscriptionUrl: 'cancel-solo-subscription',
    cancelPaypalSubscriptionUrl: 'cancel-solo-paypal-subscription',
    
    subscribeOneOff: function (data, callback) {
        return this.post('subscribe-solo-stripe-oneoff', data, _.bind(function (response) {
            if (response.success) {
                this.set({'subscription_oneoff': response.subscription_oneoff}, {silent: true});
            }
            if (callback) {
                callback(response);
            }
        }, this));
    },
    completePayPalSubscription: function (data, callback) {
        return this.post('subscribe-solo-paypal-complete', data, callback);
    },
    getReceiptUrl: function (chargeId) {
        return "/receipt/s/" + chargeId;
    },
    getInvoiceUrl: function (invoiceId) {
        return "/invoice/s/" + invoiceId;
    },
    getHostedInvoiceUrl: function (invoiceId) {
        return "/invoice/s-auth/" + invoiceId;
    },
    getPayPalReceiptUrl: function (txnId) {
        return "/receipt/p/" + txnId;
    },
    isUnlimited: function () {
        if (!this.featureCheck('upgrades')) {
            return true;
        }
        return this.hasActiveOrgs() || this.get('limits_name') == 'unlimited';
    },
    isSlackOauthAllowed: function () {
        return this.featureCheck('slack') && this.isUnlimited();
    },
    isBncAllowed: function () {
        return this.bncEnabled() && this.isUnlimited();
    },
    isTrialLimited: function () {
        if (!this.featureCheck('upgrades')) {
            return false;
        }
        return !this.hasActiveOrgs() &&  this.get('limits_name') == 'free';
    },
    isTrial: function () {
        if (!this.featureCheck('upgrades')) {
            return false;
        }
        return !this.hasActiveOrgs() && this.get('limits_name') == 'trial';
    },
    canSeeSubscription: function () {
        return true;
    },
    getLimit: function (limit) {
        var limits = this.get('limits');
        if (limits) {
            return limits[limit];
        }
    },
    isZombieLimited: function () {
        if (!this.featureCheck('upgrades')) {
            return false;
        }
        return this.getLimit('zombiehours') !== -1;
    },
    arePasswordedServersAllowed: function () {
        if (!this.featureCheck('upgrades')) {
            return true;
        }
        return this.getLimit('passworded_servers');
    },
    setZombie: function (message) {
        if (message.hardzombie) {
            this.hardZombie = message.hardzombie * 1000;
        } else if (message.softzombie) {
            this.softZombie = message.softzombie * 1000;
        }
        this.trigger('setZombie');
    },
    isZombied: function () {
        if (!this.featureCheck('upgrades')) {
            return false;
        }
        return (this.hardZombie || this.softZombie || false) && true;
    },
    getZombieDate: function () {
        if (this.isZombied()) {
            return new Date(this.hardZombie || this.softZombie);
        }
    },
    areConnectionsLimited: function () {
        if (!this.featureCheck('upgrades')) {
            return false;
        }
        if (this.getLimit('networks') === -1) {
            return false;
        }
        return true;
    },
    getRemainingConnectionQuota: function () {
        if (this.areConnectionsLimited()) {
            return this.getLimit('networks') - this.numActiveConnections();
        }
    },
    isOverQuota: function () {
        if (!this.featureCheck('upgrades')) {
            return false;
        }
        return this.getRemainingConnectionQuota() < 0;
    }
}));


module.exports = Session;



//////////////////
// WEBPACK FOOTER
// ./app/src/model/session.js
// module id = +9Dv
// module chunks = 1